import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css';
import { momentHelper } from '../../report/helpers'

const DEFAULT_ROW = 25+1
class PrintReportAnalysisInOutWork extends Component {

    constructor(...args) {
        super(...args)
        
        this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

        var cssPagedMedia = (function() {
            var style = document.createElement('style');
            document.head.appendChild(style);
            return function (rule) {
                style.innerHTML = rule;
            };
        }());
  
        cssPagedMedia.size = function(size) {
            cssPagedMedia('@page {size: ' + size + '}');
        };
        cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        let {dataList} = this.state
        if (this.props.isRange==='false'&&this.props.year!==undefined&&this.props.month!==undefined&&this.props.day!==undefined) {
            ReportStore.loadAnalysisInOutWork(this.props.year,this.props.month,this.props.day,(result)=>{
                let outgoing = []
                let incoming = []
                outgoing = this.getPagination(result.data.outgoing,result.data.in_count,result.data.in_date,result.data.out_count,result.data.out_date,'outgoing')
                incoming = this.getPagination(result.data.incoming,result.data.in_count,result.data.in_date,result.data.out_count,result.data.out_date,'incoming')
                dataList = outgoing.concat(incoming)
                this.setState({data:result.data,dataList:dataList,report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange==='true'&&this.props.startDate!==undefined&&this.props.endDate!==undefined) {
            ReportStore.loadAnalysisInOutWorkRange(this.props.startDate,this.props.endDate,(result)=>{
                let outgoing = []
                let incoming = []
                outgoing = this.getPagination(result.data.outgoing,result.data.in_count,result.data.in_date,result.data.out_count,result.data.out_date,'outgoing')
                incoming = this.getPagination(result.data.incoming,result.data.in_count,result.data.in_date,result.data.out_count,result.data.out_date,'incoming')
                dataList = outgoing.concat(incoming)
                this.setState({data:result.data,dataList:dataList,report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getDate() {
        let {day,year,month,isRange,startDate,endDate} = this.props
        if (isRange==='true') {
            let start = startDate
            let end = endDate
            return 'ประจำวันที่ '+start+' - '+end
        } else {
            let text = 'ประจำวันที่ '
            text += day+' '+momentHelper.getMonthText(month)+' '+(year-543)
            if (year==='0'||year==='00'||year===0) {
                text = 'ทั้งหมด'
            } else if (month==='0'||month==='00'||month===0) {
                text = 'ประจำปี '+(year-543)
            } else if (day==='0'||day==='00'||day===0) {
                text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+(year-543)
            }
            return text
        }  
    }

    renderRowData(data,indexs,field) {
        if (data.length===0) {
            return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item,index)=>{
                    return(
                        <tr key={index}>
                            <td className='text-center'>{item.seq}</td>
                            <td className='text-center'>{item.car_regisatrion_no}</td>
                            <td className='text-center'>{item.brand}</td>
                            <td className='text-center'>{item.damage}</td>
                            <td className='text-center'>{item.insurer_name}</td>
                            <td className='text-left'>{item.remark}</td>
                        </tr>
                    )
                })
            )
        }
    }

    renderTable(item,index,length,field) {
        return(
            <table className='table table-print-report-product-balance'>
                <tbody>
                    <tr>
                        <td className='bg-color text-center' colSpan={6}>ปริมาณรถ{field==='outgoing'?'ออก':'เข้าซ่อม'} {this.getDate()}</td>
                    </tr>
                    <tr>
                        <td className='bg-color text-center' colSpan={6}>รวมทั้งสิ้น {field==='outgoing'?(item.length>0?item[0].out_count:'0'):(item.length>0?item[0].in_count:'0')} คัน</td>
                    </tr>
                    <tr>
                        <td className='bg-color text-center' colSpan={6}>แยกตามบริษัทดังต่อไปนี้</td>
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'110px'}}>ทะเบียน</td>
                        <td className='text-center' style={{width:'90px'}}>รุ่น</td>
                        <td className='text-center' style={{width:'80px'}}>งาน</td>
                        <td className='text-center' style={{width:'110px'}}>ประกันภัย</td>
                        <td className='text-center' style={{width:'150px'}}>หมายเหตุ</td>
                    </tr>      
                    {this.renderRowData(item,index,field)}
                    <tr>
                        <td className='bg-color text-center' colSpan={6}>******หมายเหตุ รถ{field==='outgoing'?'ออก':'เข้าซ่อม'}ทั้งหมด วันที่ {field==='outgoing'?(item.length>0?item[0].out_date:'-'):(item.length>0?item[0].in_date:'-')} จำนวน {field==='outgoing'?(item.length>0?item[0].out_count:'0'):(item.length>0?item[0].in_count:'0')} คัน</td>
                    </tr>
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length,field) {
        return(  
            <div className='font-print print-report-analsis-inout-work' key={field+'-'+index}>
                <header className="text-center">
                    <h2>{field==='outgoing'?'ตารางรายงานรถออก':'ตารางรายงานรถเข้า'}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length,field)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    getPagination(data,in_count,in_date,out_count,out_date,type) {
        let itemlist = []
        data.forEach((item,index)=>{
            item = Object.assign({type:type,seq:index+1,in_count:in_count,in_date:in_date,out_count:out_count,out_date:out_date},item)
            itemlist.push(item)
        })
        let newData = []
        let allData = []
        let checkRow = 0
        itemlist.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
                checkRow++
            newData.push(item)
            
            if (checkRow===DEFAULT_ROW-1||index===itemlist.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })      
        return allData
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length,(item.length>0?item[0].type:''))
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportAnalysisInOutWork.defaultProps = {
    title: 'ตารางรายงานรถเข้า-ออก',  
    mode: '',
    workNo: ''
}
export default PrintReportAnalysisInOutWork;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportAnalysisInOutWork.js